<template lang="pug">
.input-wrapper
  label
    input(type="checkbox" v-model="internalValue")
    span.checkmark
    span.text {{ label }}
</template>

<script>
export default {
  name: 'RomatchCheckbox',
  props: {
    label: String,
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      internalValue: this.value,
    }
  },
  watch: {
    internalValue(newVal) {
      this.$emit('input', newVal)
    },
  },
}
</script>

<style scoped lang="stylus">
@import '../../assets/_forms.styl'

checkboxHeight = 16px

.input-wrapper
  input-wrapper()
  position relative
  text-align left

  input
    display inline
    width auto
    opacity 0
    height 0
    width 0
    position absolute

  .checkmark
    position absolute
    width checkboxHeight
    height checkboxHeight
    background white
    border 1px solid black
    border-radius 3px

  .text
    padding-left 20px
    line-height checkboxHeight

  label
    cursor pointer
    height checkboxHeight
    display inline

    &:hover input ~ .checkmark
      background #eee

    input:checked ~ .checkmark
      background #2196f3

  .checkmark:after
    content ''
    position absolute
    display none
    border solid white
    border-width 0 2px 2px 0
    left 4px
    top 1px
    height 8px
    width 4px
    transform rotate(45deg)

  input:checked ~ .checkmark:after
    display block
</style>
